export default "__VITE_ASSET__01e23eba__"